import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaskListUseCaseInterface } from 'domain/usecases';

interface ITaskState {
  taskList: TaskListUseCaseInterface.Result;
}

interface IPayloadTaskList
  extends PayloadAction<TaskListUseCaseInterface.Result> {}
const initialState: ITaskState = {
  taskList: { total: 0, data: [] },
};

export const TaskSlice = createSlice({
  name: 'taskList',
  initialState,
  reducers: {
    loadTask: (state, action: IPayloadTaskList) => {
      state.taskList = action.payload;
    },
  },
});

export const { loadTask } = TaskSlice.actions;

export default TaskSlice.reducer;
